import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import CardMedia from '@mui/material/CardMedia';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 450,
  bgcolor: 'transparent',
  border: '0px solid #000',
  boxShadow: 0,
  p: 0,
};

export default function Invitationvideo() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button onClick={handleOpen}>
        <span>
          <img alt = '' src={process.env.PUBLIC_URL + "images/invitationtwo.png"} className="invitationthree "  />
 
        </span>
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <CardMedia
            component='video'
            autoPlay //////////////////Used to auto autoplay the video//////////////
            controls="top"
            image={"https://storage.googleapis.com/airlift-cdn/Bharatheviane.mp4"}
            className="cardmediathree"
         
          />
        </Box>
      </Modal>
    </div>
  );
}


